import { CATALOGS, PRODUCT_AREA_PRESETS, useRegistry } from "../registry";

/**
 * Single cross-catalog picker for filtering runs by product area. "Common" lists the
 * curated presets (Consumer App, Cloud, Firmware, …); every other registry key follows,
 * grouped by catalog. The value is a registry key (or "" for all).
 */
export default function ProductFilter({
  value,
  onChange,
  idPrefix,
}: {
  value: string;
  onChange: (next: string) => void;
  idPrefix: string;
}) {
  const { data: registry, isLoading } = useRegistry();
  const presetKeys = new Set(PRODUCT_AREA_PRESETS.flatMap((p) => p.keys));

  return (
    <label className="form-control" htmlFor={`${idPrefix}-product-area`}>
      <span className="label-text text-xs">Product area</span>
      <select
        id={`${idPrefix}-product-area`}
        className="select select-bordered select-sm max-w-56"
        value={value}
        disabled={isLoading}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">All</option>
        <optgroup label="Common">
          {PRODUCT_AREA_PRESETS.map((preset) => (
            <option key={`preset-${preset.label}`} value={preset.keys[0]}>
              {preset.label}
            </option>
          ))}
        </optgroup>
        {CATALOGS.map(({ catalog, label }) => {
          const entries = (registry?.catalogs[catalog] ?? []).filter(
            (e) => !presetKeys.has(e.key),
          );
          if (entries.length === 0) return null;
          return (
            <optgroup key={catalog} label={label}>
              {entries.map((e) => (
                <option key={`${catalog}-${e.key}`} value={e.key}>
                  {e.parent ? "  " : ""}
                  {e.name}
                  {e.is_family ? " (all)" : ""}
                </option>
              ))}
            </optgroup>
          );
        })}
      </select>
    </label>
  );
}
